import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { IconComponent } from '@ftr/foundation'
/*
 * FTR Web App Imports
 */
import { PageComponent } from '@ftr/foundation'
import { LinkGridModule } from '~app/shared/link-grid/link-grid.module'

/*
 * FTR Admin App Imports
 */
import { GlobalAdminPage } from '~admin/app/pages/admin/global-admin.page'

@NgModule({
  imports: [
    IconComponent,
    LinkGridModule,
    PageComponent,
    RouterModule.forChild([
      {
        path: '',
        data: {
          breadcrumb: 'Global Admin',
          title: 'Global Admin',
        },
        children: [
          {
            path: '',
            component: GlobalAdminPage,
          },
          {
            path: 'users',
            loadChildren: () =>
              import('~admin/app/pages/admin/users/admin-users-page.module').then(m => m.AdminUsersPageModule),
          },
          {
            path: 'court-systems',
            loadChildren: () =>
              import('~admin/app/pages/admin/court-systems/admin-court-systems.module').then(
                m => m.AdminCourtSystemsModule,
              ),
          },
        ],
      },
    ]),
  ],
  declarations: [GlobalAdminPage],
})
export class GlobalAdminPagesModule {}
